import {ListItem} from "@domain/common/list-view/list-item";

/**
 * Filtre de visibilité des prestations
 */
export class PrestFiltre implements ListItem {
    type: string;
    modificateur: string;
    idFiltre: number;
    libelle: string;
    actif: boolean;
    used?: boolean;
    usedHere?: boolean;

    getKey(): number {
        return this.idFiltre;
    }
}

/**
 * Enum des types de filtre
 */
export enum TypeFiltreChar {
    TYPE_MOT_CLE = "M",
    TYPE_TYPE_ENTITE = "T",
    TYPE_CATEGORIE = "C",
    TYPE_ORGANISATION = "O",
    TYPE_CODE_ACTIVITE = "A",
    TYPE_TYPE_CHARGE = "K",
    TYPE_RUBRIQUE = "R"
}